import { authToken, teladocApi } from '@td/api';

const requestDefaults = {
  action_cd: "DATAAUTOMATIONACTION_MERGE",
  actor_poly_type_cd: "Mrn",
  job_type_cd: "JOBTYPE_TEAMSUPPORT",
  priority: 110
}

const queueLinkBenefits = (memberId, eligMrnId, teamSupportTicket) => {
  const request = {
    portal_source_mrn_id: memberId,
    elig_mrn_id: eligMrnId,
    team_support_ticket: teamSupportTicket,
    ...requestDefaults
  }
  return teladocApi.post(`/v4/data_automation_triggers`, request, authToken.get());
};

export default queueLinkBenefits;
